module.exports = __webpack_public_path__ + "img/pic4.e8c06205.png";